import { motion } from "framer-motion";

const FAQS = [
  {
    q: "Can foreigners buy property in Dubai?",
    a: "Yes. Foreign nationals can own freehold property outright in designated areas such as Dubai Marina, Downtown Dubai, Palm Jumeirah, Dubai Hills and MBR City — with no annual property tax, no capital gains tax and no income tax on rent for individuals.",
  },
  {
    q: "What are the total costs when buying?",
    a: "Budget roughly 7–8% on top of the purchase price: the 4% DLD transfer fee, around 2% agency fee, a trustee office fee of about AED 4,200, and — if financing — a 0.25% mortgage registration fee plus a bank valuation.",
  },
  {
    q: "How do I verify a broker or a project?",
    a: "Every agent must hold a RERA broker card and every listing a Trakheesi permit — check both on the Dubai REST app before paying anything. For off-plan, confirm the project is registered and payments go into a RERA-regulated escrow account.",
  },
  {
    q: "Can buying property get me a Golden Visa?",
    a: "Property worth AED 2 million or more can qualify the owner for a 10-year UAE Golden Visa — mortgaged and off-plan properties can qualify too, subject to conditions.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-20 lg:py-28">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-center"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold-light/90 font-medium mb-6">Common questions</p>
        <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-[#F8F6F0] leading-tight">
          Asked by <span className="italic gold-text">every first-time buyer.</span>
        </h2>
      </motion.div>
      <div className="mt-12 space-y-3">
        {FAQS.map((f, i) => (
          <motion.details
            key={f.q}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.5 }}
            className="gold-ring rounded-xl bg-ink-card/60 group"
            data-testid={`faq-item-${i + 1}`}
          >
            <summary className="cursor-pointer list-none flex items-center justify-between gap-4 p-5 font-serif text-lg text-[#F8F6F0] hover:text-gold-pale transition-colors">
              {f.q}
              <span className="text-gold text-xl leading-none transition-transform duration-300 group-open:rotate-45">+</span>
            </summary>
            <p className="px-5 pb-5 text-sm text-zinc-400 leading-relaxed">{f.a}</p>
          </motion.details>
        ))}
      </div>
    </div>
  </section>
);
